var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"pr-6",attrs:{"cols":"12"}},[_c('v-btn',{attrs:{"color":"primary","block":""},on:{"click":function($event){return _vm.$emit('create',{filterType:'group',filterValues:[],channel:'email',recipient:''})}}},[_vm._v(_vm._s(_vm.$t('notifications.createNewBtn')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }